import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Dialog, DialogContent, DialogActions, Button, Box, Typography, Divider } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  paper: {
    borderRadius: 12,
    width: 460,
    paddingTop: 24,
    paddingBottom: 24,
    paddingLeft: 32,
    paddingRight: 32,
    boxSizing: 'border-box'
  },
  title: {
    fontWeight: 600,
    fontSize: 18,
    marginBottom: 8
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 12,
    paddingTop: 8
  },
  cancelButton: {
    textTransform: 'none'
  },
  confirmButton: {
    backgroundColor: '#00445D',
    color: '#fff',
    '&:hover': { backgroundColor: '#00374C' },
    textTransform: 'none'
  }
}));

export default function ConfirmUpdateDialog({ open, onClose, onConfirm, folderName }) {
  const classes = useStyles();

  const handleConfirm = () => {
    if (typeof onConfirm === 'function') onConfirm();
  };

  return (
    <Dialog open={!!open} onClose={onClose} PaperProps={{ className: classes.paper }} BackdropProps={{ style: { backgroundColor: 'rgba(0,0,0,0.45)' } }}>
      <Box>
        <Typography className={classes.title}>Confirm Folder Update</Typography>
        <Divider style={{ borderBottom: '1px solid #E0E0E0', marginBottom: 12 }} />
        <DialogContent>
          <Typography>Are you sure you want to update the '{folderName}' folder?</Typography>
        </DialogContent>
        <Divider style={{ borderBottom: '1px solid #E0E0E0', marginTop: 12 }} />
        <DialogActions className={classes.actions}>
          <Button onClick={onClose} variant="outlined" className={classes.cancelButton}>Cancel</Button>
          <Button onClick={handleConfirm} variant="contained" className={classes.confirmButton}>Yes, Update</Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
